import React, { Children, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import EquipRow from 'components/table/EquipRow';
import { Loto } from 'model/Loto';
import { useRecoilValue } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { YN_TYPE } from 'types/enumType';
import {
  convertDeptIdToString,
  isUserRoleByAccept,
  transferEmails,
} from 'util/commonUtil';

type LotoConclusionTableProps = {
  conclusionList: Loto[];
  page: number;
  count: number;
  onClick: (loto: Loto) => void;
  confirmModalOpen: (event: React.MouseEvent, id: number) => void;
  oldLotoYn: YN_TYPE;
  isPopup?: boolean;
};

export default function LotoConclusionTable({
  conclusionList,
  page,
  count,
  onClick,
  confirmModalOpen,
  oldLotoYn,
  isPopup = false,
}: LotoConclusionTableProps) {
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userInfoState);
  const isUser = isUserRoleByAccept(userInfo);
  const getTrByLog = (log: Loto, idx: number): ReactElement => {
    const rowSpan = !log?.orderEquips?.length ? 1 : log?.orderEquips?.length;

    return (
      <>
        <tr onClick={() => onClick(log)}>
          <td rowSpan={rowSpan}>{idx + 1 + (page - 1) * count}</td>
          <td rowSpan={rowSpan} className={'left pl'}>
            {`${log.orderNo}${log.linkOrderNo ? `\n(${log.linkOrderNo})` : ''}`}
          </td>
          <td rowSpan={rowSpan} className={'left'}>
            {log.orderName}
          </td>
          <td rowSpan={rowSpan}>{log.workDate}</td>
          <td rowSpan={rowSpan}>{convertDeptIdToString(log.regDeptId)}</td>
          <td rowSpan={rowSpan} className={'pl'}>
            {log.selfWorkYn === YN_TYPE.N && log.coopApproveYn === YN_TYPE.Y
              ? `(${transferEmails(log?.coopEmail)})`
              : YN_TYPE.N}
          </td>
          <EquipRow
            orderEquip={
              !log?.orderEquips || log?.orderEquips?.length === 0
                ? null
                : log.orderEquips[0]
            }
          />
          <td className={'pl'} rowSpan={rowSpan}>
            {log.lockConfirmYn === YN_TYPE.Y
              ? `${log.lockUserName}\r\n${log.lockConfirmDate}`
              : log.lockConfirmYn}
          </td>
          <td rowSpan={rowSpan}>{log.unlockApproveUserName}</td>
          <td className={'pl'} rowSpan={rowSpan}>
            {log.unlockConfirmYn === YN_TYPE.Y
              ? `${log.unlockUserName}\r\n${log.unlockConfirmDate}`
              : log.unlockConfirmYn}
          </td>
          {!isUser && !isPopup && (
            <td rowSpan={rowSpan}>
              <button
                className={
                  oldLotoYn === 'Y' ? 'gray_white_btn' : 'orange_white_btn'
                }
                type={'button'}
                onClick={(event: React.MouseEvent) =>
                  confirmModalOpen(event, log.lotoId)
                }
              >
                {oldLotoYn === 'Y'
                  ? `${t('button.release')}`
                  : `${t('button.regist')}`}
              </button>
            </td>
          )}
        </tr>
        {log.orderEquips?.length > 1 &&
          Children.toArray(
            log.orderEquips.map((equip, index) => {
              if (index === 0) {
                return null;
              }
              return (
                <tr onClick={() => onClick(log)}>
                  <EquipRow orderEquip={log?.orderEquips[index]} />
                </tr>
              );
            }),
          )}
      </>
    );
  };

  return (
    <table className={'tbl_ht01 lotoLog-table'}>
      <caption>{t('conclusion.searchList')}</caption>
      <colgroup>
        <col width={'50'} />
        <col width={'120'} />
        <col width={''} />
        <col width={'100'} />
        <col width={'50'} />
        <col width={''} />
        <col width={''} />
        {/* <col width={'50'} /> */}
        <col width={'50'} />
        <col width={'50'} />
        <col width={'50'} />
        {/* <col width={'50'} /> */}
        <col width={'50'} />
        <col width={'50'} />
        <col width={'50'} />
        {/* <col width={'50'} /> */}
        <col width={'50'} />
        <col width={'50'} />
        <col width={'50'} />
        {!isUser && !isPopup && <col width={'50'} />}
      </colgroup>
      <thead>
        <tr>
          <th>{'No'}</th>
          <th>{t('orderManagement.orderNum')}</th>
          <th>{t('orderManagement.orderTitle')}</th>
          <th>{t('orderManagement.workDate')}</th>
          <th>{t('lotoSetting.manageDept')}</th>
          <th>{t('coop.workYn')}</th>
          <th>{t('device.deviceName')}</th>
          {/* <th>{t('orderManagement.lo-to')}</th> */}
          <th>{t('home.prod')}</th>
          <th>{t('home.elec')}</th>
          <th>{t('home.mech')}</th>
          {/* <th>{t('home.etc')}</th> */}
          <th>{t('home.prod')}</th>
          <th>{t('home.elec')}</th>
          <th>{t('home.mech')}</th>
          {/* <th>{t('home.etc')}</th> */}
          <th>{t('home.confirmLocking')}</th>
          <th>{t('home.lotoOpen')}</th>
          <th>{t('conclusion.unlockConfirm')}</th>
          {!isUser && !isPopup && <th>{t('conclusion.oldLoto')}</th>}
        </tr>
      </thead>
      <tbody>
        {!conclusionList || conclusionList?.length === 0 ? (
          <tr>
            <td colSpan={20}>{t('conclusion.noData')}</td>
          </tr>
        ) : (
          Children.toArray(
            conclusionList.map((conclusion, index) =>
              getTrByLog(conclusion, index),
            ),
          )
        )}
      </tbody>
    </table>
  );
}
